import styled from "@emotion/styled";

export const TextContainer = styled.div(({theme}) => ({
  gridColumn: "1/-1",
  position: "relative",
  zIndex: 3,
  display: "flex",
  flexDirection: "column",
  marginBlock: theme?.breakpoints?.isMobile ? "auto 15px" : "auto 23px",
  paddingInline: theme?.breakpoints?.isMobile ? 10 : "calc((50% - 650px))",
}));

export const ScrollToNextSection = styled.div(({theme}) => ({
  position: "absolute",
  left: "calc(50% - 12px)",
  bottom: theme?.breakpoints?.isMobile ? 50 : 20,
  zIndex: 3,
  width: 25,
  height: 40,
  cursor: "pointer",
}));

export const HashtagsWrapper = styled.div(({theme}) => ({
  display: "flex",
  gap: 10,
}));

export const GradientTop = styled.div(({theme}) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  zIndex: 2,
  background:
    "linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 51.56%, rgba(0, 0, 0, 0) 100%, rgba(0, 0, 0, 0) 100%)",
  width: "100%",
  height: "12%",
}));

export const GradientBottom = styled.div(({theme}) => ({
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 2,
  background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 58.57%)",
  width: "100%",
  height: "55%",
}));
